import React, { useState, useEffect } from 'react'
import ListPeriodsTable from './ListPeriodsTable'
import { Pagination, Select, Button, Spin, message, Alert } from 'antd'
import { exportListFinishPeriods, getListBrand, getListFinishPeriods } from '../../../services/api/3dApi'
import { getUserList } from '../../../services/api/UserService'
import moment from "moment"
import { Link } from 'react-router-dom'
import FilterDateRangeV2 from '../../shared/FilterDateRangeV2'
import FilterProductType from '../../batchesV3/components/filters/FilterProductType'
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import SearchField from '../../home/components/filters/SearchField'
import UseDebounce from '../../users/helpers/UseDebounce'
import { PERIODS } from '../../batches-mark-periods/helper/ListPeriods'

function ListPeriodsPage() {
    const [listPeriods, setListPeriods] = useState([])
    const [periods, setPeriods] = useState([])
    const [error, setError] = useState('')
    const [listError, setListError] = useState({})
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [batchName, setBatchName] = useState([])
    const [listUser, setListUser] = useState([])
    const [listBrand, setListBrand] = useState([])
    const [brand, setBrand] = useState([])
    const [user, setUser] = useState([])
    const [type, setType] = useState([])
    const [timeAt, setTimeAt] = useState({})
    const [loading, setLoading] = useState(false)

    const debounceBatchName = batchName === '' ? UseDebounce(batchName, 0) : UseDebounce(batchName, 500)

    const fetchListPeriods = async () => {
        setLoading(true)
        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (!!batchName && !!batchName.length) payload.batch_names = batchName
            if (!!brand && !!brand.length) payload.brand_name = brand
            if (!!periods) payload.period_name = periods
            if (!!user && !!user.length) payload.marker = user
            if (!!type && !!type.length) payload.product_types = type
            if (Object.keys(timeAt).length && !!timeAt.from && !!timeAt.to) {
                payload['mark_date[from]'] = timeAt.from
                payload['mark_date[to]'] = timeAt.to
            }

            const { data: res } = await getListFinishPeriods(payload)
            const { data, success, error: mess } = { ...res }

            if (success) {
                setListPeriods(data.data)
                setTotal(data.total)
                setPage(data.page)
                setLimit(data.limit)
            } else {
                setError(mess)
                message.error(mess)
            }
        } catch (error) {
            setError(error.message)
            message.error(error.message)
        }
        finally {
            setLoading(false)
        }
    }

    const _getListBrand = async () => {
        const payload = {
            limit: 10000,
            page: 1
        }
        try {
            const { data: Data } = await getListBrand(payload)
            const { data, success, message } = Data
            const Brands = data.Brands.map(i => ({ value: i.name, label: i.name }))
            if (success) {
                setListBrand(Brands)
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const _getListUser = async () => {
        try {
            const { data, message, success } = await getUserList({ page: 1, limit: 10000, })
            if (!success) {
                console.log(message)
                setListError({ userError: message })
            } else {
                setListUser(data.users)
            }
        } catch (error) {
            console.log(error)
            setListError({ userError: error.message })
        }
    }

    const handleBatchName = (field, value) => {
        if (!!value && value.trim().includes(',')) {
            const Value = Array.from(new Set(value.replace(' ', ',').split(',').filter(i => i !== '')))
            setBatchName(Value)
        } else {
            !!value ? setBatchName([value]) : setBatchName([])
        }
        setPage(1)
    }

    const handleChangeBrand = (value) => {
        setBrand(value)
        setPage(1)
    }

    const handleChangeUser = (value) => {
        setUser(value)
        setPage(1)
    }

    const handleChangeType = (value) => {
        setType(value)
        setPage(1)
    }
    const handleChangeTimeAt = (field, value) => {
        setTimeAt(value)
        setPage(1)
    }

    const handleChangePeriods = (value) => {
        setPeriods(value)
    }

    const handlePageChange = (current) => {
        setPage(current)
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    const exportList = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                page: page,
                limit: limit,
            }
            if (!!batchName && !!batchName.length) payload.batch_names = batchName
            if (!!brand && !!brand.length) payload.brand_name = brand
            if (!!periods) payload.period_name = periods
            if (!!user && !!user.length) payload.marker = user
            if (!!type && !!type.length) payload.product_types = type
            if (Object.keys(timeAt).length && !!timeAt.from && !!timeAt.to) {
                payload['mark_date[from]'] = timeAt.from
                payload['mark_date[to]'] = timeAt.to
            }

            const { data } = await exportListFinishPeriods(payload)

            if (data) {
                downloadFileFromData(data, { filename: `periods-complete-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
            }

            setLoading(false)

        } catch (e) {
            setError(e.message)
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchListPeriods()
    }, [debounceBatchName, brand, user, type, periods, timeAt, limit, page])

    useEffect(() => {
        _getListBrand()
        _getListUser()
    }, [])

    const checkRoles = (roles) => {
        const Roles = !!roles && !!roles.length && roles.map((i, index) => i.name)
        if (!!Roles && Roles.includes('FFM') && !Roles.includes('Super Admin')) {
            return false
        } else {
            return true
        }
    }

    const getOptionsByObject = (objectValue) => {
        const array = []
        for (const key in objectValue) {
            if (objectValue.hasOwnProperty(key)) {
                const value = objectValue[key];
                const option = <Option key={key} value={key}>
                    {value}
                </Option>
                array.push(option)
            }
        }
        return array
    }

    const userOptions = !!listUser.length && listUser.filter((i) => (
        !!checkRoles(i.roles)
    )).map((i, index) => ({ name: i.username, value: i.username }))

    const { Option } = Select
    const disableNoBrand = !!brand && brand.length > 0 && !brand.includes('no brand')
    const disableOptionBrand = !!brand && brand.length > 0 && brand.includes('no brand')

    return (
        <div className='ListPeriodsPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mb-3 d-flex justify-content-between mt-3'>
                        <h3 className='mb-0'>Danh sách thống kê công đoạn hoàn thiện</h3>
                        <div className='d-flex align-items-center'>
                            <Button
                                className='ant-btn ant-btn-primary ml-3'
                                onClick={exportList}
                                disabled={loading}
                            >
                                Export
                            </Button>
                            <Link
                                className='ant-btn ml-3'
                                to='mark-periods'
                                disabled={loading}
                            >
                                Đánh dấu lô hoàn thiện
                            </Link>
                        </div>
                    </div>
                    <div className='jumbotron p-3 mb-3'>
                        <div className='row align-items-start'>
                            <div className='col-12 col-xl-3'>
                                <label className="d-block w-100 font-weight-bold mb-1">Tên lô</label>
                                <SearchField
                                    field='name'
                                    placeholder='Tìm kiếm theo tên Lô...'
                                    onChangeInput={handleBatchName}
                                />
                            </div>
                            <div className='col-12 col-xl-3'>
                                <label className='font-weight-bold mb-1'>Loại sản phẩm</label>
                                <FilterProductType
                                    productTypes={type}
                                    onChangeProductType={handleChangeType}
                                />
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block mb-1">Brand</label>
                                <Select
                                    name='brand'
                                    className='brand'
                                    mode={'multiple'}
                                    onChange={(value) => handleChangeBrand(value)}
                                    value={brand}
                                    allowClear
                                    showArrow
                                    placeholder='Chọn brand name'
                                    style={{ width: '100%' }}
                                >
                                    <Option disabled={disableNoBrand} value='no brand'> No brand</Option>
                                    {listBrand.length && listBrand.map((i, index) => (
                                        <Option disabled={disableOptionBrand} value={i.value} key={index}>{i.label}</Option>
                                    ))
                                    }
                                </Select>
                            </div>
                            <div className='col-12 col-xl-2 mb-3'>
                                <label className="font-weight-bold d-block mb-1">Công đoạn</label>
                                <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    placeholder='-- Chọn công đoạn --'
                                    allowClear
                                    value={periods || []}
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    onChange={handleChangePeriods}
                                >
                                    {!!Object.keys(PERIODS).length &&
                                        getOptionsByObject(PERIODS)
                                    }
                                </Select>
                            </div>
                            <div className='col-12 col-xl-2'>
                                <label className="font-weight-bold mb-1">Thời gian</label>
                                <FilterDateRangeV2
                                    field='packaged_at'
                                    onDatesChange={handleChangeTimeAt}
                                    showTime={true}
                                />
                            </div>



                            <div className='col-12 col-xl-3'>
                                <div className="FilterSelect">
                                    <div className='font-weight-bold mb-1'>Người thực hiện</div>
                                    {!!Object.keys(listError).length && !!listError.userError ? <Alert message={listError.userError} type={'error'} /> :
                                        <Spin spinning={loading}>
                                            <Select
                                                mode="multiple"
                                                style={{ width: '100%' }}
                                                showArrow={true}
                                                placeholder="Vui lòng chọn người thực hiện bạn muốn tìm kiếm"
                                                defaultValue={user}
                                                onChange={handleChangeUser}
                                                value={user || []}
                                                allowClear
                                            >
                                                {!!userOptions && !!userOptions.length &&
                                                    userOptions.map((option, index) => {
                                                        return <Option key={index} value={option.value}>{option.name}</Option>
                                                    })
                                                }
                                            </Select>
                                        </Spin>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && <div className='text-danger'>{error}</div>}
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>
                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                </div>}
                            onChange={handlePageChange}
                            onShowSizeChange={handleShowSizeChange}
                            disabled={loading}
                        />
                    </div>
                    <Spin spinning={loading} tip='Loading...'>
                        <ListPeriodsTable
                            listPeriods={listPeriods}
                            setType={setType}
                            loading={loading}
                        />
                    </Spin>
                    <Pagination
                        current={page}
                        total={total}
                        pageSize={limit}
                        className='text-right'
                        showSizeChanger
                        showQuickJumper
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        onShowSizeChange={handleShowSizeChange}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default ListPeriodsPage